/* VH Our Story (sections/vh-story-*.liquid). PRESENTATION ONLY: no cart, customer or network calls.
   Included by every vh-story section; the first run handles every story section on the page, later runs find nothing new.
   Everything is complete and readable without JS or GSAP; motion is added on top (desktop pins only above 1000px). */
(function () {
  if (document.documentElement.getAttribute('data-vh-story-js') === '1') return;
  document.documentElement.setAttribute('data-vh-story-js', '1');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var all = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var one = function (s, r) { return (r || document).querySelector(s); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };

  function setup(roots, motion) {
    /* mission + values: split each statement into words (visible at rest; motion dims them first) */
    roots.forEach(function (root) {
      all('[data-words]', root).forEach(function (p) {
        if (p.getAttribute('data-split')) return;
        p.setAttribute('data-split', '1');
        p.innerHTML = p.textContent.trim().split(/\s+/).map(function (w) { return '<span class="vh-story-w">' + esc(w) + '</span>'; }).join(' ');
      });
      /* founders: hover or focus opens a portrait (desktop); the click opens the bio drawer (assets/vh-learn.js) */
      var fps = all('[data-vh-fp]', root);
      fps.forEach(function (b, i) {
        var open = function () { if (window.innerWidth > 1000) fps.forEach(function (x, k) { x.classList.toggle('on', k === i); }); };
        b.addEventListener('mouseenter', open); b.addEventListener('focus', open);
      });
      /* why: the first fact drives the picture until motion takes over */
      setFact(root, 0);
      if (RM) all('video[data-vh-loop]', root).forEach(function (v) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} });
    });
    if (!motion) return;
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
    ScrollTrigger.config({ignoreMobileResize: true});

    roots.forEach(function (root) {
      var kind = root.getAttribute('data-vh-story');
      if (kind === 'hero') {
        var frame = one('[data-vh-frame]', root);
        gsap.from(all('.vh-story-sh-h, .vh-story-sh-side, .vh-story-sh-frame', root), {autoAlpha: 0, y: 40, duration: 1.15, stagger: .13, ease: 'power3.out', delay: .1});
        if (frame) {
          gsap.fromTo(frame, {scale: .9, borderRadius: 40}, {scale: 1, borderRadius: 22, ease: 'none', scrollTrigger: {trigger: frame, start: 'top 85%', end: 'top 15%', scrub: true}});
          var media = one('video, img', frame);
          if (media) gsap.fromTo(media, {yPercent: -4}, {yPercent: 4, ease: 'none', scrollTrigger: {trigger: frame, start: 'top bottom', end: 'bottom top', scrub: true}});
        }
      }
      if (kind === 'mission') {
        var mv = one('.vh-story-mv', root); if (mv) mv.classList.add('vh-story-js-words');
        all('[data-words]', root).forEach(function (p) {
          gsap.to(p.querySelectorAll('.vh-story-w'), {opacity: 1, stagger: .1, ease: 'none', scrollTrigger: {trigger: p, start: 'top 80%', end: 'bottom 45%', scrub: true}});
        });
      }
    });

    var mm = gsap.matchMedia();
    mm.add('(min-width: 1001px)', function () {
      var undo = [];
      roots.forEach(function (root) {
        var kind = root.getAttribute('data-vh-story');
        if (kind === 'timeline') {
          /* each chapter slides in, then holds while you read it; the big year rolls with the cards */
          var pin = one('[data-vh-pin]', root), track = one('[data-vh-track]', root), cards = all('.vh-story-ch', root), n = cards.length;
          if (!pin || n < 2) return;
          var tlSec = one('.vh-story-tl', root); if (tlSec) { tlSec.classList.add('vh-story-js-tl'); undo.push(function () { tlSec.classList.remove('vh-story-js-tl'); }); }
          var ticks = all('.vh-story-tl-rail b', root), cap = one('[data-vh-cap]', root), fill = one('[data-vh-fill]', root), years = one('[data-vh-years]', root);
          var caps = cards.map(function (c) { var h = c.querySelector('h3'); return h ? h.textContent : ''; });
          var step = function () { return cards[1].offsetLeft - cards[0].offsetLeft; };
          var MOVE = 1, HOLD = .55, cur = 0;
          var tl = gsap.timeline({defaults: {ease: 'power2.inOut'}, scrollTrigger: {trigger: pin, start: function () { return 'top ' + (window.VHK && VHK.top ? VHK.top() : 0) + 'px'; }, end: function () { return '+=' + window.innerHeight * (n - 1) * .95; }, pin: true, scrub: 1, invalidateOnRefresh: true,
            onUpdate: function (st) {
              var t = st.progress * tl.duration(), k = Math.min(n - 1, Math.max(0, Math.round((t - HOLD * .5) / (MOVE + HOLD) + .35)));
              if (k !== cur) { cur = k; if (cap) cap.textContent = caps[k]; ticks.forEach(function (b, i) { b.classList.toggle('on', i <= k); }); }
              if (fill) gsap.set(fill, {scaleX: st.progress});
            }}});
          tl.to({}, {duration: HOLD * .5});
          for (var k = 1; k < n; k++) {
            var at = HOLD * .5 + (k - 1) * (MOVE + HOLD);
            (function (k) { tl.to(track, {x: function () { return -step() * k; }, duration: MOVE}, at); })(k);
            if (years) tl.to(years, {yPercent: -100 * k / n, duration: MOVE}, at);
            tl.fromTo(cards[k], {opacity: .35, y: 36}, {opacity: 1, y: 0, duration: MOVE}, at).to(cards[k - 1], {opacity: .3, duration: MOVE}, at);
          }
          tl.to({}, {duration: HOLD});
        }
        if (kind === 'why') {
          /* whichever fact crosses the middle of the screen drives the picture */
          var sec = one('.vh-story-why', root); if (!sec) return;
          sec.classList.add('vh-story-js-why'); setFact(root, 0);
          all('[data-vh-fact]', root).forEach(function (f, i) {
            ScrollTrigger.create({trigger: f, start: 'top 55%', end: 'bottom 55%', onToggle: function (s) { if (s.isActive) setFact(root, i); }});
          });
          undo.push(function () { sec.classList.remove('vh-story-js-why'); all('[data-vh-fact]', root).forEach(function (f) { f.classList.remove('on'); }); });
        }
      });
      return function () { undo.forEach(function (f) { f(); }); };
    });

    /* containers marked .vh-rv fade up once; created after the pins so their start points include the pin spacing */
    roots.forEach(function (root) {
      all('.vh-rv', root).forEach(function (el) {
        gsap.fromTo(el, {autoAlpha: 0, y: 48}, {autoAlpha: 1, y: 0, duration: 1.15, ease: 'power3.out', scrollTrigger: {trigger: el, start: 'top 88%', once: true}});
      });
    });
    ScrollTrigger.sort();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh()); });
    /* window load: ScrollTrigger refreshes itself on load (autoRefreshEvents), no second pass */
    (window.VHK && VHK.refresh ? VHK.refresh() : ScrollTrigger.refresh());
  }

  function setFact(root, k) {
    var facts = all('[data-vh-fact]', root), pics = all('[data-vh-whypic] img', root), cap = one('[data-vh-whycap]', root);
    if (!facts.length) return;
    facts.forEach(function (f, i) { f.classList.toggle('on', i === k); });
    pics.forEach(function (p, i) { p.classList.toggle('on', i === k); });
    if (cap) cap.textContent = facts[k].getAttribute('data-cap') || '';
  }

  function start() {
    var roots = all('.vh-story[data-vh-story]:not([data-vh-on])');
    if (!roots.length) return;
    roots.forEach(function (r) { r.setAttribute('data-vh-on', '1'); });
    if (window.VHK && VHK.withGsap) VHK.withGsap(function (ok) { setup(roots, ok); });
    else setup(roots, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* theme editor: a re-rendered section gets the static behavior (no pins) */
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('.vh-story[data-vh-story]'); if (r) setup([r], false); });
})();
